import { render, staticRenderFns } from "./popertyDetails.vue?vue&type=template&id=ba2a8d42"
import script from "./popertyDetails.vue?vue&type=script&lang=js"
export * from "./popertyDetails.vue?vue&type=script&lang=js"
import style0 from "./popertyDetails.vue?vue&type=style&index=0&id=ba2a8d42&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba2a8d42')) {
      api.createRecord('ba2a8d42', component.options)
    } else {
      api.reload('ba2a8d42', component.options)
    }
    module.hot.accept("./popertyDetails.vue?vue&type=template&id=ba2a8d42", function () {
      api.rerender('ba2a8d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/popertyDetails.vue"
export default component.exports